import { useDeviceScreenHeight } from "../../hooks/use-device-screen-height";
import { CSSProperties, useEffect, useState } from "react";

export function useDeviceScreenHeightValue() {
  const deviceScreenHeight = useDeviceScreenHeight();
  const [discreteScreenHeight, setDiscreteScreenHeight] = useState<number | undefined>(deviceScreenHeight);
  useEffect(() => {
    // This is a quick workaround for the issue of window height being variable on mobile devices
    // because of navigation bar being hidden when user scrolls
    if (
      typeof deviceScreenHeight === "number" &&
      typeof window !== "undefined" &&
      (typeof discreteScreenHeight === "undefined" ||
        Math.abs(deviceScreenHeight - discreteScreenHeight) > 75 * window.devicePixelRatio)
    ) {
      setDiscreteScreenHeight(deviceScreenHeight);
    }
  }, [deviceScreenHeight]);

  const deviceScreenHeightStrWithFallback = discreteScreenHeight ? `${discreteScreenHeight}px` : "100dvh";

  const styleObj = {
    "--screen-height": deviceScreenHeightStrWithFallback,
  } as CSSProperties;

  return styleObj;
}
